// Section colour palette + ordering shared between the live ComponentOverlayLayer and the
// ComponentLayoutThumbnail. Mirrors scripts/page-layout/page-layout-viewer.ts so the in-page
// debug overlay and the standalone layout viewer stay visually consistent.

export const SECTION_COLORS: Record<string, string> = {
  Top: '#4338ca',
  Left: '#1d4ed8',
  'Center Top': '#059669',
  'Center Left': '#0891b2',
  'Center Right': '#7c3aed',
  Right: '#d97706',
  'Center Bottom': '#be185d',
  Bottom: '#475569',
};

export const DEFAULT_COLOR = '#374151';

export function getSectionColor(section: string): string {
  return SECTION_COLORS[section] ?? DEFAULT_COLOR;
}

// Render order for the thumbnail, top-to-bottom. Superset of every template's section flow:
// dynamic pages use Top/Center Top/Right/Center Bottom/Bottom; landing pages swap the Center
// Top/Right pair for the Center Left/Right column pair. Sections not present on the current
// page are absent from `sectionStats` and skipped, so a shared order is safe.
export const THUMBNAIL_SECTION_ORDER = [
  'Top',
  'Center Top',
  'Center Left',
  'Center Right',
  'Right',
  'Center Bottom',
  'Bottom',
] as const;

// Maps the loader's SectionName keys (build-page-data.server.ts / getSectionComponents) to the
// human labels used for overlay data-attributes and thumbnail headers.
export const SECTION_LABEL_BY_KEY: Record<string, string> = {
  top: 'Top',
  centerTop: 'Center Top',
  right: 'Right',
  centerBottom: 'Center Bottom',
  bottom: 'Bottom',
  centerLeft: 'Center Left',
  centerRight: 'Center Right',
};
